module.exports = __webpack_public_path__ + "img/img_pic2@2x.e56bc79e.png";